import { Link } from '@mui/material'
import { useNavigate } from 'react-router-dom'

type Props = {
  href?: string
  value?: string
}
export const LinkCell = ({ href, value }: Props) => {
  const navigate = useNavigate()

  if (!value || value === '-' || !href) {
    return '-'
  }

  return (
    <Link
      href={href}
      onClick={e => {
        e.stopPropagation()
        navigate(href)
        e.preventDefault()
      }}
      sx={{
        whiteSpace: 'normal',
        wordBreak: 'break-word',
        lineHeight: '1.2',
        display: 'flex',
        alignItems: 'center',
        height: '100%',
        color: 'primary.main',
        textDecoration: 'none',
        cursor: 'pointer',
        '&:hover': {
          textDecoration: 'underline',
        },
      }}
    >
      {value}
    </Link>
  )
}
